/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */

export type TracksControllerTracksListSortBy =
  | (typeof TracksControllerTracksListSortBy)[keyof typeof TracksControllerTracksListSortBy]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TracksControllerTracksListSortBy = {
  uploaded: "uploaded",
  title: "title",
  type: "type",
  duration: "duration",
  published: "published",
  random: "random",
  album: "album",
  releaseDate: "releaseDate",
  price: "price",
  popular: "popular",
} as const;
